export const UPDATE_AGENT_TICKET_COLLISION_STATUS =
  'collisions/UPDATE_AGENT_TICKET_COLLISION_STATUS'
export const FETCH_AGENT_COLLISION_STATUSES_SUCCESS =
  'collisions/FETCH_AGENT_COLLISION_STATUSES_SUCCESS'
